"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAddress = void 0;
const formatAddress = (address) => {
    if (!address) {
        return "";
    }
    const { streetLine1, streetLine2, city, state, country, zipCode } = address;
    let toReturn = streetLine1;
    if (streetLine2) {
        toReturn += `, ${streetLine2}`;
    }
    if (city) {
        toReturn += `, ${city}`;
    }
    if (state) {
        toReturn += `, ${state}`;
    }
    if (zipCode) {
        toReturn += ` ${zipCode}`;
    }
    if (country) {
        toReturn += `, ${country}`;
    }
    return toReturn;
};
exports.formatAddress = formatAddress;
